// extracted by mini-css-extract-plugin
export default {"backward":"BackwardIcon_backward__a1+Lh"};